import React, { useContext } from 'react';
import classNames from 'classnames';
import style from './ProgressBar.module.scss';
import { ProgressBarContext, ThemeContext } from '../App/App';

export default ({ progress }: { progress: number }) => {
	const { styles: themeStyle } = useContext(ThemeContext);
	const isProgressBarEnabled = useContext(ProgressBarContext);

	if (!isProgressBarEnabled) return null;
	return (
		<div className={classNames(themeStyle.progressBarBackground, style.background)}>
			<div
				className={classNames(themeStyle.progressBar, style.bar)}
				style={{ width: `${progress}%` }}
			/>
		</div>
	);
};
